













































































import { Vue, Component } from 'vue-property-decorator'

import { cloneDeep } from 'lodash'

import { BtnList } from '@/types/common/btn'
import { RateListMap } from '@/types/newPersion'

import { saveNewPersion, getNewPersionList, getRateList } from '../../../utils'

import FormItem from '@/components/formItem/index.vue'

import BaseInfo from '../../../components/baseInfo/index.vue'
import NewFooter from '../../../components/newFooter'
import PersionCalculatorDialog from './persionCalculatorDialog.vue'
import {
  inputForm,
  formItemBtn,
  btnList,
  radioList,
  indexList,
} from '../utils'
@Component({
  components: { BaseInfo, FormItem, NewFooter, PersionCalculatorDialog },
})
export default class extends Vue {
  dialogShow = false;

  // 输入表单
  form = inputForm;

  propData: {title: string; name: string}[] =[]

  formClone = inputForm;

  // 以当前生活水平，您希望养老金每月可领取 下快速填充按钮组
  formItemBtn = formItemBtn;

  // 底部按钮数组
  btnList = btnList;

  // 通货膨胀率相关
  radioObj = {
    // 通货膨胀率按钮状态
    inflationRate: 'default',
    // 通货膨胀率下单选按钮组
    radioList: radioList,

    //  指标数组
    indexList: indexList,
    //  指标状态（索引）
    indexValue: 0,
  };

  rateList: RateListMap[] = [];
  async created () {
    const res = await Promise.all([
      await getNewPersionList(),
      await getRateList(),
    ])
    const res0 = cloneDeep(res[0])
    this.form = cloneDeep(res[0])
    if (!this.form.assumeInflationRate || this.form.assumeInflationRate === res[1][2].value) {
      this.form.assumeInflationRate = res[1][2].value
    } else {
      this.radioObj.inflationRate = 'customize'
    }
    this.propData = [{
      title: '预计退休年龄',
      name: res0.retireAge + '岁'
    }, {
      title: '预计养老金领取年限',
      name: res0.deathAge + '年'
    }]
    this.formClone = res[0]
    const _rateList: RateListMap[] = []
    res[1].forEach((item: RateListMap) => {
      if (item.name !== '默认通胀率') {
        _rateList.push(item)
      } else {
        this.formClone.assumeInflationRate = item.value
        this.formClone.currentMonthAmount = ''
      }
    })
    this.rateList = _rateList
  }

  private nextPage (item: BtnList) {
    const { btnType } = item
    switch (btnType) {
      case 'reset':
        this.form = this.formClone
        this.radioObj.indexValue = 0
        this.radioObj.inflationRate = 'default'
        break
      case 'confirm':
      default:
        this.handleConfirm()
        break
    }
  }

  private async handleConfirm () {
    if (!this.$validator(this.$refs.form)) {
      const res = await saveNewPersion({ ...this.form, assumeInflationRate: Number(this.form.assumeInflationRate) })
      if (res) {
        this.$emit('on-click', 'output')
      }
    }
  }

  private handleFormItemLabelBtn () {
    this.dialogShow = true
  }

  private handleFormItemBtn (count: string) {
    this.form.currentMonthAmount = count
  }

  private handleBaseInfoBtn (type: string) {
    this.$router.push('/pension/card/' + type)
  }

  private handleRadioIndex (idx: number) {
    this.radioObj.indexValue = idx === 0 ? 1 : 0
  }

  private handleRadio (type: string) {
    if (type === 'default') {
      this.radioObj.indexValue = 0
      this.form.assumeInflationRate = this.formClone.assumeInflationRate
    }
  }

  private handleDialogClose () {
    this.dialogShow = false
  }

  private handleDialogConfirm (currentMonthAmount: string) {
    this.form.currentMonthAmount = currentMonthAmount
    this.dialogShow = false
  }
}
